import React from "react";
import { Box } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { DASH } from "../../pages/Dashboard/dashboardTheme";
import ChartTooltip from "./ChartTooltip";

/** Barras horizontales (ranking por categoría). */
export default function VerticalBarChart({
  data = [],
  labelKey = "label",
  valueKey = "count",
  height = 200,
  labelWidth = 90,
  barSize = 12,
  radius = [0, 2, 2, 0],
  valueLabel = "",
  colorKey = "color",
  defaultColor = "#111110",
}) {
  return (
    <Box sx={{ width: "100%", height }}>
      <ResponsiveContainer>
        <BarChart data={data} layout="vertical" margin={{ top: 0, right: 8, left: 0, bottom: 0 }}>
          <XAxis type="number" hide />
          <YAxis
            type="category"
            dataKey={labelKey}
            width={labelWidth}
            tick={{ fontSize: 10, fill: DASH.textSecondary }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            content={<ChartTooltip valueLabel={valueLabel} />}
            cursor={{ fill: "rgba(17,17,16,0.03)" }}
          />
          <Bar dataKey={valueKey} radius={radius} barSize={barSize}>
            {data.map((entry, i) => (
              <Cell key={i} fill={entry[colorKey] || defaultColor} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}
